import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './Hero.module.css';
import slide01 from '../../../Assets/Home/Slider/slide01.webp';
import slide02 from '../../../Assets/Home/Slider/slide02.webp';
import slide03 from '../../../Assets/Home/Slider/slide03.webp';

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = React.useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        arrows: false,
        afterChange: (current) => setCurrentSlide(current),
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    const handleCall = () => {
        window.open('tel:+919922966739', '_blank');
    };

    /* Slide content — focus keyword in slide 1 */
    const slides = [
        {
            img: slide01,
            alt: 'Best Marketing Company in Pune — Yeskondo Media 360° Campaigns',
            heading: 'Best Marketing Company in Pune',
            sub: 'Comprehensive 360° Marketing Strategies',
        },
        {
            img: slide02,
            alt: 'Digital Marketing Agency Pune — Yeskondo Media Brand Building',
            heading: 'Build Your Brand with Advanced Digital Marketing',
            sub: 'Expert Digital Marketing Agency in Pune',
        },
        {
            img: slide03,
            alt: 'Creative Advertising Agency Pune — Yeskondo Media Design Solutions',
            heading: 'Innovative Design & Advertising Solutions',
            sub: 'Unleash Your Brand\'s Full Potential',
        },
    ];

    return (
        <div className={styles.hero} role="banner">

            {/* ── ONLY H1 ON THE ENTIRE PAGE — focus keyword for Google ── */}
            <h1 className={styles.seo_h1}>
                Best Marketing Company in Pune | Yeskondo Media Pvt Ltd
            </h1>

            <div className={styles.frame}>
                <div className={styles.sound}>
                    <p>OFF</p>
                    <div className={styles.equalizer}></div>
                    <p>SOUND</p>
                </div>
                <div className={styles.nav}>
                    <p
                        className={`${styles.prev} ${styles.np_btn}`}
                        onClick={goToPrev}
                        role="button"
                        aria-label="Previous slide"
                    ></p>
                    <p
                        className={`${styles.next} ${styles.np_btn}`}
                        onClick={goToNext}
                        role="button"
                        aria-label="Next slide"
                    ></p>
                </div>
                <div className={styles.counter} aria-hidden="true">
                    <p>{`${currentSlide + 1}`}</p>
                </div>
            </div>

            <Slider ref={sliderRef} {...settings} className={styles.hero_slider}>
                {slides.map((slide, index) => (
                    <div className={styles.slide} key={index}>
                        <img
                            src={slide.img}
                            alt={slide.alt}
                            className={styles.sliderImage}
                            loading={index === 0 ? 'eager' : 'lazy'}
                        />
                        <div className={styles.content}>
                            {/* H2 for slide titles — only ONE H1 exists above */}
                            <h2 className={styles.title}>{slide.heading}</h2>
                            <p className={styles.subtitle}>{slide.sub}</p>
                            <button
                                className={styles.ghostbutton}
                                onClick={handleCall}
                                aria-label="Call Yeskondo Media — Best Marketing Company in Pune"
                            ></button>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default Hero;